import { useEffect, useState } from 'react';

import { TaskInstance } from '@web/shiftTasks/types/TaskInstance';
import { TaskStatuses } from '@web/shiftTasks/types/TaskStatuses';
import { useCompleteShiftTask } from '@web/shiftTasks/hooks/useCompleteTask';

type Props = {
  shiftTask: TaskInstance;
};

export const useShiftTaskInstanceModalInner = ({ shiftTask }: Props) => {
  const { mutate } = useCompleteShiftTask();
  // this prevents marking task as completed right after opening modal
  // to handle re-opened task with all subtasks completed
  const [subtaskCompletedSuccessfully, setSubtaskCompletedSuccessfully] = useState(false);
  const onCompleteSubtask = () => setSubtaskCompletedSuccessfully(true);

  useEffect(() => {
    if (
      subtaskCompletedSuccessfully &&
      shiftTask.status === TaskStatuses.PENDING &&
      shiftTask.subtasks.every((subtask) => subtask.status === TaskStatuses.DONE)
    ) {
      mutate(shiftTask.id);
    }
  }, [mutate, shiftTask, subtaskCompletedSuccessfully]);

  return {
    onCompleteSubtask,
  };
};
